import React from 'react';

const ContactUs = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8 text-gray-800 bg-white">
      <h1 className="text-3xl font-bold mb-4">Contact Us</h1>
      <p className="mb-4">Have questions? We're here to help you with anything related to your purchases or account.</p>

      <ul className="mb-6">
        <li><strong>Instagram:</strong> <a href="https://instagram.com/jd.gaming_store_" className="text-blue-500 underline">@jd.gaming_store</a></li>
    
        <li><strong>Address:</strong> Mundkhede, Jamner, Jalgaon, Maharashtra – 424206, India</li>
      </ul>

      <p>You can also visit us at <a href="https://jivangaming.in" className="text-blue-500 underline">jivangaming.in</a></p>
    </div>
  );
};

export default ContactUs;
